import type { FaireProductEntity } from "../../entity_types/product";

export const p_kudhwvys3y: FaireProductEntity = {
  token: "p_kudhwvys3y",
  type: "product",
  name: "White Flower Wedding Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/22f663267f925c7074e56de6c508c391c1f5954067bac0d9fe4696fbfe23107e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0aa5f522ac8245f3084533a5b410a34a3a1f334d91b1e9162452b09a69586e6f.png",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:40.091Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
